import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import SBNiceDate from '@components/utils/SBNiceDate'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { AdminInvite as AdminInviteModel } from '@models/AdminInvite'
import {
  createAdminInvite,
  getAdminInvites,
  selectAdminInvites,
  setAdminInviteQuery,
} from '@store/AdminInviteReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { App, Button } from 'antd'
import { DEFAULT_ERROR, DEFAULT_SUCCESS } from '../../../App'

const AdminInvitesPage = () => {
  const { message } = App.useApp()
  const dispatch = useAppDispatch()
  const { hasAccess } = useHasAccess()
  const adminInvites = useAppSelector(selectAdminInvites())
  const { query, isLoading } = useAppSelector((state) => state.adminInvite)

  const columns: TableColumnsType<AdminInviteModel> = [
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Invitation Date',
      render: (record: AdminInviteModel) => (
        <SBNiceDate date={record.createdAt} />
      ),
    },
    {
      title: 'Resend Invitiation',
      render: (record) =>
        hasAccess(Permission.createAdmin) && (
          <Button
            type="primary"
            onClick={() => {
              dispatch(createAdminInvite(record))
                .then(() => {
                  message.success(DEFAULT_SUCCESS)
                })
                .catch(() => {
                  message.error(DEFAULT_ERROR)
                })
            }}
          >
            Resend
          </Button>
        ),
    },
  ]

  const fetchAdminInvites = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }
    dispatch(setAdminInviteQuery(newQuery))
    dispatch(getAdminInvites(newQuery))
  }

  const { handleTableChange } = useTableUrlSync<AdminInviteModel>({
    onParamsChange: fetchAdminInvites,
  })

  return (
    <Page
      permissions={Permission.createAdmin}
      pageTitle={{
        title: 'Pending invitations',
        level: 4,
      }}
    >
      <SBTable
        columns={columns}
        dataSource={adminInvites}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default AdminInvitesPage
